// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "spot-fe-loan/trade/spot/pro/static/css/" + chunkId + "." + {"326":"bb416e98","1111":"24516f37","1311":"aed012d0","2622":"59ba0f70","3312":"af441584","5150":"34427ca7","6042":"a131d3ab"}[chunkId] + ".css";
};